module.exports = __webpack_public_path__ + "static/img/shop_storage_3.c1d0a5ae.jpg";